import {useEffect, useState} from 'react';
import {SEQUENCE_ANNOTATION} from 'constants/annotation-types.js';
import ethereum from 'decentralized/ethereum.js';

export const useComments = ({
    works,
    linkType=SEQUENCE_ANNOTATION,
}) => {
    const [comments, setComments] = useState([]);
    useEffect(() => {
        ethereum.xanadu.getFlattenedAnnotations(
            linkType,
            ... works.map(x => x.newSequence))
            .then(a => {
                setComments([...a]);
            });
    }, [works, setComments]);

    return {comments};
};
